import { HStack, Stack, VStack, IconButton, Icon, useColorMode, Switch, Center, Image, Tooltip, BoxProps } from '@chakra-ui/react';
import CustomButton from '../../../../../iZUMi-UI-toolkit/src/components/Buttons/CustomButton/CustomButton';
import Card from '../../../../../iZUMi-UI-toolkit/src/components/Card/Card';
import { Modal } from '../../../../../iZUMi-UI-toolkit/src/components/Modal/Modal';
import { ToastLink, useCustomToast } from '../../../../../iZUMi-UI-toolkit/src/components/Toast/Toast';
import { CustomNumberInput } from '../../../../../iZUMi-UI-toolkit/src/components/Inputs/NumberInput/NumberInput';
import { amount2Decimal, formatNumber } from '../../../../../utils/tokenMath';
import { Text } from '../../../../../iZUMi-UI-toolkit/src/components/Typography/Typography';
import { RootDispatch } from '../../../../../state/store';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRematchDispatch } from '../../../../../hooks/useRematchDispatch';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { MdAdd } from 'react-icons/md';
import { getColorThemeSelector } from '../../../../../utils/funcs';
import { useWeb3WithDefault } from '../../../../../hooks/useWeb3WithDefault';
import { i_text_copy_bold } from '../../../../../style';
import CurrentPriceBlock from '../../../../components/CurrentPriceBlock';
import { TokenIconSymbol } from '../../../../components/TokenIconSymbol';
import { findPoolEntryByPoolKey, niZiForDesiredBoost } from '../../../../../state/models/farm/iZiSwap/oneSide/funcs';
import { RootState } from '../../../../../state/store';
import { isNumeric } from '../../../../../utils/valid';
import { FarmOneSideiZiContractVersion, TokenSymbol } from '../../../../../types/mod';
import { identity } from '../../../../../utils/funcs';
import BigNumber from 'bignumber.js';
import useTokenEntity from '../../../../../state/models/hooks/useTokenEntity';
import { FarmRefreshHandle } from './PoolList';
import { useGasPrice } from '../../../../../hooks/useGasPrice';
import ApproveTokenButton from '../../../../components/ApproveTokenButton';
import useOneSideiZiEntity, { OneSideDepositParams } from '../../../../../state/models/hooks/farm/useOneSideiZiEntity';
import { MiningCallbacks } from '../../../../../state/models/hooks/farm/common/callbacks';
import { PoolEntryState } from '../../../../../state/models/farm/iZiSwap/oneSide/types';
import { TokenIcons } from '../../../../Trade/components/TokenIcons';
import { FeeRate } from '../../../../Trade/components/FeeRate';
import { FARM_CONFIG } from '../../../../../config/bizConfig';
import { VeiZiNftEntry, VeNFTBoostBlock } from '../../../components/VeNFTBoostBlock';
import useWindowDimensions from '../../../../../hooks/useWindowDimension';
import { useIZiToken } from '../../../../../hooks/useiZiToken';
import { useTranslation } from 'react-i18next';
import { getChain, getTxLink } from '../../../../../config/chains';

const IconWithSymbol = TokenIconSymbol;

type AddLiquidityModalProps = {
    isOpen: boolean;
    onClose: () => void;
    //onSuccess?: () => void;
    entry: PoolEntryState;
} & BoxProps &
    FarmRefreshHandle;

const AddLiquidityModal: React.FC<AddLiquidityModalProps> = ({
    //refreshPosition,
    refreshPoolListDataAndPosition,
    isOpen,
    onClose,
    //onSuccess,
    entry,
    ...rest
}) => {
    const toast = useCustomToast();
    const { t } = useTranslation();
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const { dispatch } = useRematchDispatch((dispatch: RootDispatch) => ({
        dispatch,
    }));
    const [iZiSwitch, setiZiSwitch] = useState(false);
    const { gasPrice } = useGasPrice();
    const { iZiToken } = useIZiToken();

    const {
        account: accountModel,
        farmOneSideiZi: { poolEntryList },
        farmOneSideiZiAddLiquidity: { mintForm },
        veiZiFarmOneSideiZiAddLiquidity: { mintForm: veiZiMintForm },
    } = useSelector((state: RootState) => state);

    const { account, chainId, web3 } = useWeb3WithDefault();

    const poolEntry = findPoolEntryByPoolKey(poolEntryList, mintForm.positionPoolKey);

    useEffect(() => {
        if (!account || !web3 || !poolEntry.meta.positionPoolKey) {
            return;
        }
        const tokens = [poolEntry.meta.tokenA, poolEntry.meta.tokenB];
        for (const token of tokens) {
            const param = {
                token,
                account,
                web3,
                chainId,
                spender: poolEntry.meta.miningContract,
            } as unknown as any;
            dispatch.account.fetchTokenBalanceIfMissing(param);
            dispatch.account.fetchTokenApprovedIfMissing(param);
        }
    }, [account, poolEntry, chainId, dispatch, web3]);

    const tokenAEntity = useTokenEntity(poolEntry.meta.tokenA, poolEntry.meta.miningContract);
    const tokenBEntity = useTokenEntity(poolEntry.meta.tokenB, poolEntry.meta.miningContract);

    const oneSideEntity = useOneSideiZiEntity(poolEntry);
    
    const tokeniZiEntity = useTokenEntity(iZiToken, poolEntry.meta.miningContract);

    const maxPriceAByB = Math.max(poolEntry.data.priceAByBDecimal, poolEntry.data.oraclePriceAByBDecimal);
    const minPriceAByB = Math.min(poolEntry.data.priceAByBDecimal, poolEntry.data.oraclePriceAByBDecimal);

    const stdPoint = poolEntry.data.oracleTick;

    const priceDiffRate = (maxPriceAByB - minPriceAByB) / maxPriceAByB;

    const isVeiZiContract = poolEntry.meta.contractVersion === FarmOneSideiZiContractVersion.VEIZI;

    const tokenUniAmountDecimal = isVeiZiContract ? veiZiMintForm.tokenUniAmountDecimal : mintForm.tokenUniAmountDecimal;
    const tokenLockAmountDecimal = isVeiZiContract ? veiZiMintForm.tokenLockAmountDecimal : mintForm.tokenLockAmountDecimal;
    const iZiAmountDecimal = isVeiZiContract ? 0 : mintForm.iZiAmountDecimal;

    const iZiAmount = isVeiZiContract ? 0 : mintForm.iZiAmount;
    const tokenUniAmount = isVeiZiContract ? veiZiMintForm.tokenUniAmount : mintForm.tokenUniAmount;

    let totaliZiAmountDecimal = iZiAmountDecimal;

    if (poolEntry.meta.tokenUni?.symbol === TokenSymbol.IZI) {
        totaliZiAmountDecimal += tokenUniAmountDecimal;
    }
    if (poolEntry.meta.tokenLock?.symbol === TokenSymbol.IZI) {
        totaliZiAmountDecimal += tokenLockAmountDecimal;
    }
    const extraveiZi = Math.max(veiZiMintForm.veiZiForFullBoostDecimal - poolEntry.userData.veiZiDecimal, 0);
    const { width } = useWindowDimensions();
    const changeLineWidth = 960;
    const isChangeLine = changeLineWidth > width ? true : false;

    console.log('extraveiZi: ', extraveiZi);

    const { tokenAAmount, tokenBAmount, totaliZiAmount } = useMemo(() => {
        if (!poolEntry.meta?.tokenA?.symbol || !poolEntry.meta?.tokenB?.symbol) {
            return {
                tokenAAmount: '0',
                tokenBAmount: '0',
                totaliZiAmount: '0',
            };
        }
        const tokenAIsUni = poolEntry.meta.tokenA.symbol === poolEntry.meta.tokenUni.symbol;
        const isVeiZiContract = poolEntry.meta.contractVersion === FarmOneSideiZiContractVersion.VEIZI;
        const tokenUniAmount = isVeiZiContract ? veiZiMintForm?.tokenUniAmount : mintForm?.tokenUniAmount;
        const tokenLockAmount = isVeiZiContract ? veiZiMintForm?.tokenLockAmount : mintForm?.tokenLockAmount;
        let totaliZiAmount = isVeiZiContract ? 0 : mintForm.iZiAmount;
        if (poolEntry.meta.tokenUni.symbol === TokenSymbol.IZI) {
            totaliZiAmount += tokenUniAmount;
        }
        if (poolEntry.meta.tokenLock.symbol === TokenSymbol.IZI) {
            totaliZiAmount += tokenLockAmount;
        }
        if (tokenAIsUni) {
            return {
                tokenAAmount: String(tokenUniAmount ?? 0),
                tokenBAmount: String(tokenLockAmount ?? 0),
                totaliZiAmount: String(totaliZiAmount),
            };
        } else {
            return {
                tokenAAmount: String(tokenLockAmount ?? 0),
                tokenBAmount: String(tokenUniAmount ?? 0),
                totaliZiAmount: String(totaliZiAmount),
            };
        }
    }, [poolEntry.meta, veiZiMintForm, mintForm]);

    const unApprovedList: string[] = [];
    if (!tokenAEntity.isApproved(tokenAAmount)) {
        unApprovedList.push(poolEntry.meta.tokenA.symbol);
    }
    
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            w={{ base: '73%', lg: '744px' }}
            h="unset"
            title={t('Add liquidity')}
            {...rest}
            overflowX="hidden"
        >
            <VStack w="100%" spacing="10px" alignItems="start">
                <Card variant="deep" w="100%" h={isChangeLine ? 'unset' : '108px'} mt="-10px">
                    <Stack
                        direction={isChangeLine ? 'column' : 'row'}
                        w="100%"
                        spacing="10px"
                        p={isChangeLine ? '14px 20px 14px 25px' : '14px 20px 14px 40px'}
                        justifyContent="space-between"
                    >
                        <HStack>
                            <TokenIcons tokenA={entry.meta.tokenA} tokenB={entry.meta.tokenB} initialToggle={entry.meta.initialToggle} />
                            <FeeRate
                                tokenA={entry.meta.tokenA}
                                tokenB={entry.meta.tokenB}
                                initialToggle={entry.meta.initialToggle}
                                feeTier={entry.meta.feeTier as FeeTier}
                            />
                        </HStack>
                        <CurrentPriceBlock
                            tokenA={poolEntry.meta.tokenA}
                            tokenB={poolEntry.meta.tokenB}
                            price={poolEntry.data.priceAByBDecimal}
                            toggle={poolEntry.meta.initialToggle}
                            handleToggle={() => {
                                dispatch.farmOneSideiZi.togglePoolMetaInitialToggle(poolEntry.meta.positionPoolKey);
                            }}
                            w={isChangeLine ? '100%' : '241px'}
                            mt={isChangeLine ? '40px !important' : 'unset'}
                        />
                    </Stack>
                </Card>
                <Stack direction="row" h="35px" w="150px" alignItems="center">
                    <Text color={colorTheme('tertiary.500', 'tertiary.300')} variant="caption">
                        {t('Volume')}
                    </Text>
                    <Tooltip
                        label={`Token ${poolEntry.meta.tokenUni.symbol} will be added into the iZiSwap pool to earn fees and 
                            token ${poolEntry.meta.tokenLock.symbol} will be locked in the mining contract. \n 
                            The amounts required are calculated with instant price, which may have a slight difference in the actual executive process.`}
                    >
                        <IconButton
                            size="sm"
                            aria-label=""
                            variant="ghost"
                            isRound={true}
                            icon={<Icon as={AiOutlineInfoCircle} boxSize="16px" />}
                        />
                    </Tooltip>
                </Stack>

                <Stack
                    direction={isChangeLine ? 'column' : 'row'}
                    bg={colorTheme('#FDFDFD', '#423854')}
                    pt="16px"
                    w="100%"
                    boxShadow={colorTheme('0px 0px 27px 5px rgba(218, 206, 230, 0.25)', 'undefined')}
                    borderRadius="6px"
                    px={isChangeLine ? '20px' : '30px'}
                    pb="16px"
                >
                    <VStack
                        bg={colorTheme('#fff', '#34294A')}
                        boxShadow={colorTheme('0px 0px 9px 5px rgba(240, 226, 254, 0.25)', '0px 0px 27px 5px rgba(29, 6, 51, 0.25)')}
                        borderRadius="6px"
                        border={colorTheme('0.5px solid #DDDAE1', '1px solid #8664CE')}
                        pb={isChangeLine ? '16px' : '10px'}
                        w={isChangeLine ? '100%' : '270px'}
                    >
                        <Stack
                            direction={isChangeLine ? 'column' : 'row'}
                            h={isChangeLine ? 'unset' : '31px'}
                            px="17px"
                            justifyContent="space-between"
                            w="100%"
                            borderBottom={colorTheme('1px solid', '0.5px solid')}
                            borderColor={colorTheme('tertiary.100', 'tertiary.600')}
                            alignItems="center"
                        >
                            <IconWithSymbol mt={isChangeLine ? '10px' : 'unset'} token={poolEntry.meta.tokenUni} />

                            <Text
                                color="tertiary.300"
                                variant="caption"
                                w={isChangeLine ? '100%' : 'unset'}
                                pb={isChangeLine ? '10px' : 'unset'}
                                textAlign={isChangeLine ? 'center' : 'unset'}
                            >
                                {formatNumber(accountModel.tokenBalance[poolEntry.meta.tokenUni.symbol]?.[0] ?? 0)}
                            </Text>
                        </Stack>

                        <VStack w={isChangeLine ? '100%' : 'unset'}>
                            <CustomNumberInput
                                inputValue={Number(tokenUniAmountDecimal).toFixed(4)}
                                onBlur={(value) => {
                                    if (isNumeric(value)) {
                                        if (entry.meta.contractVersion === FarmOneSideiZiContractVersion.V1) {
                                            dispatch.farmOneSideiZiAddLiquidity.updateTokenUniAmount({
                                                amountDecimal: value as number,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        } else {
                                            dispatch.veiZiFarmOneSideiZiAddLiquidity.updateTokenUniAmount({
                                                amountDecimal: value as number,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        }
                                    }
                                }}
                                errorInfo={
                                    tokenUniAmountDecimal <= accountModel.tokenBalance[poolEntry.meta.tokenUni?.symbol]?.[0]
                                        ? ''
                                        : 'Not enough token'
                                }
                            />
                            <HStack w={isChangeLine ? '100%' : 'unset'} px={isChangeLine ? '10px' : 'unset'}>
                                <CustomButton
                                    w={isChangeLine ? '50%' : '88px'}
                                    h="24px"
                                    variant="tertiary"
                                    text="Clear"
                                    fontClass={i_text_copy_bold}
                                    onClick={() => {
                                        if (entry.meta.contractVersion === FarmOneSideiZiContractVersion.V1) {
                                            dispatch.farmOneSideiZiAddLiquidity.updateTokenUniAmount({
                                                amountDecimal: 0,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        } else {
                                            dispatch.veiZiFarmOneSideiZiAddLiquidity.updateTokenUniAmount({
                                                amountDecimal: 0,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        }
                                    }}
                                />
                                <CustomButton
                                    w={isChangeLine ? '50%' : '88px'}
                                    h="24px"
                                    variant="primary2"
                                    text="All"
                                    ml={isChangeLine ? '10px' : 'unset'}
                                    fontClass={i_text_copy_bold}
                                    onClick={() => {
                                        if (entry.meta.contractVersion === FarmOneSideiZiContractVersion.V1) {
                                            dispatch.farmOneSideiZiAddLiquidity.updateTokenUniAmount({
                                                amountDecimal: accountModel.tokenBalance[poolEntry.meta.tokenUni?.symbol]?.[0]
                                                    ? accountModel.tokenBalance[poolEntry.meta.tokenUni?.symbol]?.[0] *
                                                      FARM_CONFIG.ALL_FACTOR
                                                    : 0,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        } else {
                                            dispatch.veiZiFarmOneSideiZiAddLiquidity.updateTokenUniAmount({
                                                amountDecimal: accountModel.tokenBalance[poolEntry.meta.tokenUni?.symbol]?.[0]
                                                    ? accountModel.tokenBalance[poolEntry.meta.tokenUni?.symbol]?.[0] *
                                                      FARM_CONFIG.ALL_FACTOR
                                                    : 0,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        }
                                    }}
                                />
                            </HStack>
                        </VStack>
                    </VStack>

                    <IconButton
                        size="sm"
                        transform="rotate(90deg)"
                        aria-label=""
                        variant="ghost"
                        alignSelf="center"
                        width="15px"
                        height="15px"
                        onClick={() => {}}
                        icon={<Icon as={MdAdd} boxSize="20px" />}
                    />

                    <VStack
                        bg={colorTheme('#fff', '#34294A')}
                        boxShadow={colorTheme('0px 0px 9px 5px rgba(240, 226, 254, 0.25)', '0px 0px 27px 5px rgba(29, 6, 51, 0.25)')}
                        borderRadius="6px"
                        border={colorTheme('0.5px solid #DDDAE1', '1px solid #8664CE')}
                        pb="10px"
                        w={isChangeLine ? '100%' : '270px'}
                    >
                        <Stack
                            direction={isChangeLine ? 'column' : 'row'}
                            h={isChangeLine ? 'unset' : '31px'}
                            px="17px"
                            justifyContent="space-between"
                            w="100%"
                            borderBottom={colorTheme('1px solid', '0.5px solid')}
                            borderColor={colorTheme('tertiary.100', 'tertiary.600')}
                            alignItems="center"
                        >
                            <IconWithSymbol mt={isChangeLine ? '10px' : 'unset'} token={poolEntry.meta.tokenLock} />

                            <Text
                                color="tertiary.300"
                                variant="caption"
                                w={isChangeLine ? '100%' : 'unset'}
                                pb={isChangeLine ? '10px' : 'unset'}
                                textAlign={isChangeLine ? 'center' : 'unset'}
                            >
                                {formatNumber(accountModel.tokenBalance[poolEntry.meta.tokenLock?.symbol]?.[0] ?? 0)}
                            </Text>
                        </Stack>

                        <VStack w={isChangeLine ? '100%' : 'unset'}>
                            <CustomNumberInput
                                inputValue={Number(tokenLockAmountDecimal).toFixed(4)}
                                onBlur={(value) => {
                                    if (entry.meta.contractVersion === FarmOneSideiZiContractVersion.V1) {
                                        dispatch.farmOneSideiZiAddLiquidity.updateTokenLockAmount({
                                            amountDecimal: value as number,
                                            positionPoolKey: mintForm.positionPoolKey,
                                            chainId,
                                        });
                                    } else {
                                        dispatch.veiZiFarmOneSideiZiAddLiquidity.updateTokenLockAmount({
                                            amountDecimal: value as number,
                                            positionPoolKey: mintForm.positionPoolKey,
                                            chainId,
                                        });
                                    }
                                }}
                                errorInfo={
                                    tokenLockAmountDecimal <= accountModel.tokenBalance[poolEntry.meta.tokenLock?.symbol]?.[0]
                                        ? ''
                                        : 'Not enough token'
                                }
                            />
                            <HStack w={isChangeLine ? '100%' : 'unset'} px={isChangeLine ? '10px' : 'unset'}>
                                <CustomButton
                                    w={isChangeLine ? '50%' : '88px'}
                                    h="24px"
                                    variant="tertiary"
                                    text="Clear"
                                    fontClass={i_text_copy_bold}
                                    onClick={() => {
                                        if (entry.meta.contractVersion === FarmOneSideiZiContractVersion.V1) {
                                            dispatch.farmOneSideiZiAddLiquidity.updateTokenLockAmount({
                                                amountDecimal: 0,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        } else {
                                            dispatch.veiZiFarmOneSideiZiAddLiquidity.updateTokenLockAmount({
                                                amountDecimal: 0,
                                                positionPoolKey: mintForm.positionPoolKey,
                                                chainId,
                                            });
                                        }
                                    }}
                                />
                                <CustomButton
                                    w={isChangeLine ? '50%' : '88px'}
                                    h="24px"
                                    variant="primary2"
                                    text="All"
                                    ml={isChangeLine ? '10px' : 'unset'}
                                    fontClass={i_text_copy_bold}
                                    onClick={() => {
                                        dispatch.farmOneSideiZiAddLiquidity.updateTokenLockAmount({
                                            amountDecimal: accountModel.tokenBalance[poolEntry.meta.tokenLock?.symbol]?.[0]
                                                ? accountModel.tokenBalance[poolEntry.meta.tokenLock?.symbol]?.[0] * FARM_CONFIG.ALL_FACTOR
                                                : 0,
                                            positionPoolKey: mintForm.positionPoolKey,
                                            chainId,
                                        });
                                    }}
                                />
                            </HStack>
                        </VStack>
                    </VStack>
                </Stack>

                {poolEntry.meta.veiZiBoost && (
                    <VeNFTBoostBlock
                        entry={
                            {
                                veiZiDecimal: poolEntry.userData.veiZiDecimal,
                                nftId: poolEntry.userData.veiZiNftId,
                            } as VeiZiNftEntry
                        }
                        aprRaw={veiZiMintForm.apr}
                        aprBoost={veiZiMintForm.aprBoostVeiZi}
                        extraveiZi={extraveiZi}
                    />
                )}

                {poolEntry.meta.iZiBoost && (
                    <>
                        <Stack direction="row" h="35px" w="150px" alignItems="center">
                            <HStack mt="40px !important" w="90%">
                                <HStack>
                                    <Image
                                        w="15px"
                                        h="11px"
                                        src={process.env.PUBLIC_URL + '/assets/farm/boostIcon.svg'}
                                        mr="0 !important"
                                        pr="0 !important"
                                    />
                                    <Text variant="caption-bold" color="secondary.500">
                                        {t('Boost APR')}
                                    </Text>
                                </HStack>

                                <Switch
                                    isChecked={iZiSwitch}
                                    onChange={(e) => {
                                        setiZiSwitch(e.target.checked);
                                        dispatch.farmOneSideiZiAddLiquidity.updateTokeniZiAmount({
                                            amountDecimal: 0,
                                            positionPoolKey: mintForm.positionPoolKey,
                                            chainId,
                                        });
                                    }}
                                    size="md"
                                ></Switch>
                            </HStack>
                        </Stack>

                        {iZiSwitch && (
                            <Stack
                                direction={isChangeLine ? 'column' : 'row'}
                                bg={colorTheme('#FDFDFD', '#423854')}
                                pt="16px"
                                w="100%"
                                boxShadow={colorTheme('0px 0px 27px 5px rgba(218, 206, 230, 0.25)', 'undefined')}
                                borderRadius="6px"
                                px="30px"
                                pb="16px"
                                mt="25px !important"
                                alignItems="center"
                                p={isChangeLine ? '14px 20px 14px 25px' : '14px 20px 14px 40px'}
                            >
                                <Stack direction="column" w={isChangeLine ? '100%' : 'unset'} alignItems="center">
                                    <Stack direction="row" h="35px" justifyContent="space-between" alignItems="center">
                                        <Text color={colorTheme('tertiary.500', 'tertiary.300')} variant="caption">
                                            {t('Stake iZi to boost APR')}
                                        </Text>
                                        <Tooltip
                                            label={`Token ${TokenSymbol.IZI} will be locked in the mining contract and boost up to 2.5X APR.`}
                                        >
                                            <IconButton
                                                size="sm"
                                                aria-label=""
                                                variant="ghost"
                                                isRound={true}
                                                icon={<Icon as={AiOutlineInfoCircle} boxSize="16px" />}
                                            />
                                        </Tooltip>
                                    </Stack>
                                    <Stack direction={isChangeLine ? 'column' : 'row'}>
                                        {[1.5, 2.5].map((item, index) => {
                                            return (
                                                <CustomButton
                                                    key={index}
                                                    variant="outlinePurple"
                                                    w="147px"
                                                    h="40px"
                                                    selected={false}
                                                    onClick={() => {
                                                        const boostRate = item;
                                                        const vLiquidity = mintForm.tokenUniAmount * poolEntry.data.lockBoostMultiplier;
                                                        const totalVLiquidity = poolEntry.data.vLiquidity + vLiquidity;
                                                        const totalNIZI = poolEntry.data.totalNIZI;
                                                        let neededNiZi = niZiForDesiredBoost(
                                                            vLiquidity,
                                                            totalVLiquidity,
                                                            totalNIZI,
                                                            boostRate
                                                        );
                                                        if (neededNiZi < 0) {
                                                            neededNiZi = 0;
                                                        }
                                                        const neededNiZiDecimal = amount2Decimal(new BigNumber(neededNiZi), iZiToken) ?? 0;

                                                        dispatch.farmOneSideiZiAddLiquidity.updateTokeniZiAmount({
                                                            amountDecimal: neededNiZiDecimal,
                                                            positionPoolKey: mintForm.positionPoolKey,
                                                            chainId,
                                                        });
                                                    }}
                                                    text={
                                                        <Text
                                                            className={i_text_copy_bold}
                                                            variant="caption"
                                                            fontSize="16px"
                                                            color={colorTheme('tertiary.800', 'tertiary.50')}
                                                        >
                                                            {item.toFixed(1)}x
                                                        </Text>
                                                    }
                                                />
                                            );
                                        })}
                                    </Stack>

                                    <VStack
                                        bg={colorTheme('#fff', '#34294A')}
                                        boxShadow={colorTheme(
                                            '0px 0px 9px 5px rgba(240, 226, 254, 0.25)',
                                            '0px 0px 27px 5px rgba(29, 6, 51, 0.25)'
                                        )}
                                        borderRadius="6px"
                                        border={colorTheme('0.5px solid #DDDAE1', '1px solid #8664CE')}
                                        pb="10px"
                                    >
                                        <Stack
                                            direction={isChangeLine ? 'column' : 'row'}
                                            h={isChangeLine ? 'unset' : '31px'}
                                            px="17px"
                                            justifyContent="space-between"
                                            w="100%"
                                            borderBottom={colorTheme('1px solid', '0.5px solid')}
                                            borderColor={colorTheme('tertiary.100', 'tertiary.600')}
                                            alignItems="center"
                                        >
                                            <IconWithSymbol mt={isChangeLine ? '10px' : 'unset'} token={iZiToken} />

                                            <Text
                                                color="tertiary.300"
                                                variant="caption"
                                                w={isChangeLine ? '100%' : 'unset'}
                                                pb={isChangeLine ? '10px' : 'unset'}
                                                textAlign={isChangeLine ? 'center' : 'unset'}
                                            >
                                                {formatNumber(accountModel.tokenBalance[TokenSymbol.IZI]?.[0] ?? 0)}
                                            </Text>
                                        </Stack>

                                        <VStack>
                                            <CustomNumberInput
                                                inputValue={Number(mintForm.iZiAmountDecimal).toFixed(4)}
                                                onBlur={(value) => {
                                                    isNumeric(value) &&
                                                        dispatch.farmOneSideiZiAddLiquidity.updateTokeniZiAmount({
                                                            amountDecimal: value as number,
                                                            positionPoolKey: mintForm.positionPoolKey,
                                                            chainId,
                                                        });
                                                }}
                                                errorInfo={
                                                    mintForm.iZiAmountDecimal <= accountModel.tokenBalance[TokenSymbol.IZI]?.[0]
                                                        ? ''
                                                        : 'Not enough token'
                                                }
                                                w={isChangeLine ? '100%' : '300px'}
                                            />
                                            <HStack w={isChangeLine ? '90%' : 'unset'}>
                                                <CustomButton
                                                    w={isChangeLine ? '50%' : '88px'}
                                                    h="24px"
                                                    variant="tertiary"
                                                    text="Clear"
                                                    fontClass={i_text_copy_bold}
                                                    onClick={() => {
                                                        dispatch.farmOneSideiZiAddLiquidity.updateTokeniZiAmount({
                                                            amountDecimal: 0,
                                                            positionPoolKey: mintForm.positionPoolKey,
                                                            chainId,
                                                        });
                                                    }}
                                                />
                                                <CustomButton
                                                    w={isChangeLine ? '50%' : '88px'}
                                                    h="24px"
                                                    variant="primary2"
                                                    text="All"
                                                    fontClass={i_text_copy_bold}
                                                    onClick={() => {
                                                        dispatch.farmOneSideiZiAddLiquidity.updateTokeniZiAmount({
                                                            amountDecimal: accountModel.tokenBalance[TokenSymbol.IZI]
                                                                ? accountModel.tokenBalance[TokenSymbol.IZI]?.[0] * FARM_CONFIG.ALL_FACTOR
                                                                : 0,
                                                            positionPoolKey: mintForm.positionPoolKey,
                                                            chainId,
                                                        });
                                                    }}
                                                />
                                            </HStack>
                                        </VStack>
                                    </VStack>
                                </Stack>

                                <Stack w={isChangeLine ? 'unset' : '300px'}>
                                    <Center mt="20px !important">
                                        <VStack alignItems="center">
                                            <Text variant="caption" color="tertiary.400">
                                                {t('Current APR')}
                                            </Text>
                                            <Text variant="caption" color={colorTheme('tertiary.700', 'tertiary.100')} fontSize="18px">
                                                {formatNumber(mintForm.apr * 100)}%
                                            </Text>

                                            <HStack mt="16px !important" mb="12px !important">
                                                <Image h="13px" w="11px" src="/assets/farm/lightToV.svg" />
                                                <Text variant="caption" color={colorTheme('secondary.600', 'secondary.300')}>
                                                    {mintForm.apr > 0 ? formatNumber(mintForm.aprBoostIZI / mintForm.apr, 0, 2) : '1.0'}x
                                                </Text>
                                            </HStack>

                                            <Text variant="caption" color={colorTheme('secondary.600', 'secondary.300')}>
                                                {t('Boosted APR')}
                                            </Text>

                                            <Text variant="caption-bold" color={colorTheme('tertiary.700', 'tertiary.100')} fontSize="24px">
                                                {formatNumber(mintForm.aprBoostIZI * 100)}%
                                            </Text>
                                        </VStack>
                                    </Center>
                                </Stack>
                            </Stack>
                        )}
                    </>
                )}

                <Stack w="100%">
                    {[
                        tokenAEntity.isApproved(tokenAAmount),
                        tokenBEntity.isApproved(tokenBAmount),
                        iZiAmount === 0 || (totaliZiAmount !== '0' && tokeniZiEntity.isApproved(totaliZiAmount)),
                    ].every(identity) ? (
                        <>
                            <CustomButton
                                disabled={
                                    totaliZiAmountDecimal > accountModel.tokenBalance[TokenSymbol.IZI]?.[0] ||
                                    tokenUniAmountDecimal > accountModel.tokenBalance[poolEntry.meta.tokenUni?.symbol]?.[0] ||
                                    tokenLockAmountDecimal > accountModel.tokenBalance[poolEntry.meta.tokenLock?.symbol]?.[0] ||
                                    priceDiffRate >= 0.2
                                }
                                variant="purple"
                                text={t('Add Liquidity')}
                                fontClass={i_text_copy_bold}
                                w={isChangeLine ? '100%' : '300px'}
                                h="51px"
                                mt="30px !important"
                                mx="auto"
                                onClick={() => {
                                    const chain = getChain(chainId);
                                    const toastLink = {} as ToastLink;
                                    oneSideEntity.deposit(
                                        {
                                            uniAmount: new BigNumber(tokenUniAmount).toFixed(0),
                                            numIZi: new BigNumber(iZiAmount).toFixed(0),
                                            stdPoint,
                                        } as OneSideDepositParams,
                                        {
                                            onTransactionHash: (e: any) => {
                                                if (chain) {
                                                    toastLink.title = 'View on ' + chain.name;
                                                    toastLink.link = getTxLink(e, chain);
                                                }
                                                toast('info', 'Add Liquidity: ' + e, undefined, toastLink);
                                            },
                                            then: (e: any) => {
                                                console.log(e);
                                                toast('success', 'Add Liquidity successfully', undefined, toastLink);
                                                refreshPoolListDataAndPosition?.();
                                            },
                                            catch: (e: any) => {
                                                console.log(e);
                                                toast('error', typeof e === 'string' ? e : e.message);
                                            },
                                        } as MiningCallbacks,
                                        gasPrice
                                    );
                                }}
                            />
                            {priceDiffRate >= 0.2 && (
                                <VStack
                                    bg={colorTheme('#fff', '#34294A')}
                                    boxShadow={colorTheme(
                                        '0px 0px 9px 5px rgba(240, 226, 254, 0.25)',
                                        '0px 0px 27px 5px rgba(29, 6, 51, 0.25)'
                                    )}
                                    borderRadius="6px"
                                    border={colorTheme('0.5px solid #BB420F', '1px solid #D97E7E')}
                                    pb="10px"
                                    pt="10px"
                                    px="10px"
                                    m="0"
                                >
                                    <Text variant="caption">
                                        {/* {priceDiffRate} */}
                                        The current price fluctuates sharply, please wait for the price to stabilize to avoid impermanent
                                        loss.
                                    </Text>
                                </VStack>
                            )}
                        </>
                    ) : (
                        <Stack direction={{ base: 'column', sm: 'row' }} spacing="20px" mt="30px">
                            <ApproveTokenButton
                                tokenEntity={tokenAEntity}
                                hidden={
                                    poolEntry.meta.tokenA.symbol === TokenSymbol.IZI ||
                                    tokenAEntity.isApproved(tokenAAmount)
                                }
                                approveAmount={tokenAAmount}
                                mt="10px !important"
                                w="200px"
                                mx="auto !important"
                            />

                            <ApproveTokenButton
                                tokenEntity={tokenBEntity}
                                hidden={
                                    poolEntry.meta.tokenB.symbol === TokenSymbol.IZI ||
                                    tokenBEntity.isApproved(tokenBAmount)
                                }
                                approveAmount={tokenBAmount}
                                mt="10px !important"
                                w="200px"
                                mx="auto !important"
                            />

                            <ApproveTokenButton
                                tokenEntity={tokeniZiEntity}
                                hidden={totaliZiAmount === '0' || tokeniZiEntity.isApproved(totaliZiAmount)}
                                approveAmount={totaliZiAmount}
                                mt="10px !important"
                                w="200px"
                                mx="auto !important"
                            />
                        </Stack>
                    )}
                </Stack>
            </VStack>
        </Modal>
    );
};

export default AddLiquidityModal;
